import { useLang } from "../context/LanguageContext";

interface Props {
  onStay: () => void;
  onLeave: () => void;
}

export default function ExitModal({ onStay, onLeave }: Props) {
  const { t } = useLang();

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.45)" }}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-sm overflow-hidden"
        style={{ animation: "slideUp 0.22s cubic-bezier(0.22,1,0.36,1) both" }}
      >
        {/* Icon */}
        <div className="flex flex-col items-center px-7 pt-8 pb-2 text-center">
          <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center mb-4">
            <i className="ri-save-line text-emerald-600 text-xl" />
          </div>

          <p className="text-lg font-bold text-slate-900 leading-snug mb-2">
            {t("exitModal.title")}
          </p>
          <p className="text-sm text-slate-500 leading-relaxed">
            {t("exitModal.body")}
          </p>
        </div>

        {/* Buttons */}
        <div className="px-7 pb-7 pt-5 flex flex-col gap-2.5">
          <button
            type="button"
            onClick={onStay}
            className="w-full py-3 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("exitModal.stay")}
          </button>
          <button
            type="button"
            onClick={onLeave}
            className="w-full py-3 rounded-xl border border-slate-200 text-slate-600 hover:bg-slate-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("exitModal.leave")}
          </button>
        </div>
      </div>
    </div>
  );
}
